module.exports = __WEBPACK_EXTERNAL_MODULE_72__;


//////////////////
// WEBPACK FOOTER
// external "xml2js"
// module id = 72
// module chunks = 0